export function debounce<T extends (...args: any[]) => any>(func: T, delay: number): T {
    let timer: NodeJS.Timeout | null = null;
    return function (...args: Parameters<T>) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            func(...args);
        }, delay);
    } as T;
}